import { createRouter, createWebHistory } from "vue-router";
import { scrollTo } from "@thegetty-private/getty-ui";
import { routerHelpers } from "@thegetty-private/rad-app-utils";

const localCatch = routerHelpers.localCatch;

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  //defining the scrolling behavior when navigating using Vue router
  //for more options check: https://router.vuejs.org/guide/advanced/scroll-behavior.html
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // we use a promise/timeout to allow Vue to render the page enough to scroll down
      return new Promise((resolve, _reject) => {
        setTimeout(() => {
          resolve(savedPosition);
        }, 500);
      });
    }

    // only scroll to top if paginating through results
    if (to.query.from != from.query.from) {
      return scrollTo({ top: 0 });
    }

    // if we're playing with the search facets, don't change where we are on the page
    if (
      to.name == "search" &&
      from.name == "search" &&
      to?.state?.scrollToTop == undefined
    ) {
      return;
    }

    //DEFAULT: scroll to the top of the page unless the URL contains a tab parameter
    return { left: 0, top: 0 };
  },
  routes: [
    {
      path: "/",
      component: () => import("@/views/layout-base.vue").catch(localCatch),
      children: [
        {
          path: "/",
          name: "home",
          redirect: (_to) => {
            return { name: "search" };
          }
        },
        {
          path: "/search",
          name: "search",
          component: () =>
            import("@/components/pages/search/index.vue").catch(localCatch)
        },
        {
          path: "/item",
          component: () =>
            import("@/views/with-object-page-layout.vue").catch(localCatch),
          children: [
            {
              path: ":indexedId",
              name: "work",
              component: () =>
                import("@/components/pages/work/index.vue").catch(localCatch)
            }
          ]
        }
      ]
    }
  ]
});

/**
 * handles errors thrown by the router, and reloads the page if the error is an asset mismatch error or if we're in a dev environment
 *
 * @params {error} error - the error thrown by the router
 * @params {to} to - the route we were navigating to when the error was thrown
 */
router.onError((error, to) => routerHelpers.onError(error, to));

export default router;
